module.exports = __webpack_public_path__ + "static/media/mbway.8f1eca65.png";